import type { FaireProductEntity } from "../../entity_types/product";

export const p_9xgwpt8frm: FaireProductEntity = {
  token: "p_9xgwpt8frm",
  type: "product",
  name: "SAINT SAUVEUR",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/c875b8a908d5e525759c96dc8d1eaa3e2ef1a227332947b8c6fe17f624d9be9b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ecf2ce5751db841dbdb04e199b6965d139d55ab43d6606f0d677c4ae1a393ccf.jpeg",
    "https://cdn.faire.com/fastly/24e41864aa185f867fac1a33907aab21f764d3d9d993ad01694728a821b1ed10.jpeg"
  ],
  priceDollars: 18,
  description: "Smoky late night walks along the meandering street of Rue Saint-Sauveur. Hidden corners, whispered secrets and the ever present feeling of endless possibilities. This scent embodies the spirit of those magical moments with velvety notes of cashmere wood, sweet tobacco, and a delicate hint of smoke.\n\nsweet tobacco, rum, cashmere wood, smoke, ambrette\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n7 ounces (198g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:05.390Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
